<template>
  <b-navbar-nav class="mx-auto">
    <li v-for="(route, index) in menu" :key="index" class="list-inline-item">
      <router-link :to="{name:route.routeName}"  class="nav-link">{{route.label}}</router-link>
    </li>
  </b-navbar-nav>
</template>

<script>
import { primary } from '../nav'

export default {
  data () {
    return {
      menu: primary
    }
  }
}
</script>
